import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { getter, Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import {
  getSelectedState,
  HeaderThElement,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import IconButton from "../../components/common/IconButton";
import { MdDelete, MdKeyboardBackspace } from "react-icons/md";
import AppDialog, {
  CustomAppDialog,
  CustomDialogCloseButton,
  DialogCloseButton,
} from "../../components/dialog/Dialog";
import {
  assignLeadToUser,
  bulkUploadLeads,
  deleteLead,
  downloadLeadExcel,
  getAllAdNames,
  getAllLeads,
  getLeadAssignUserHistory,
  updateLeadStageStatus,
} from "./services/lead.services";
import {
  clearLeadID,
  clearLeadStageID,
  setactiveTabIndex,
  setLeadFilterDetails,
  setLeadID,
  setLeadStageID,
} from "./leadSlice";
import { checkAcessRights, parseQueryParams } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  EXCEL_EXPORT_ACCESS,
  INSERT_ACCESS,
  LEADTYPE,
} from "../../_contstants/common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { getAllActiveUsers } from "../user/services/user.services";
import { IUser } from "../user/userModel";
import { ErrorToast, SuccessToast } from "../../components/toast/Toasts";
import moment from "moment";
// import { setQuotationInformation } from "../quotation/quotationSlice";
import LeadFilter from "./LeadFilter";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import LinkEdit from "../../components/drawer/LinkEdit";
import { LiaInfoSolid } from "react-icons/lia";
import FormDatePicker from "../../components/formFields/FormDateField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTimePicker from "../../components/formFields/FormTimeField";
import FormTextArea from "../../components/formFields/FormTextArea";
import ButtonForAll from "../../components/common/ButtonForAll";
// import FormCheckbox from "../../components/formFields/FormCheckbox";
import { RxCross1 } from "react-icons/rx";
import {
  getFollowupsByInquiryID,
  insertFollowUp,
  updateFollowUpStatus,
} from "../inquiry/services/inquiry.services";
import IconComponent from "../../components/common/IconComponent";
import { RiEdit2Fill } from "react-icons/ri";
import { getAllActiveLeadStage } from "../leadstage/services/leadStage.services";
import { ILeadStage } from "../leadstage/leadStageModel";
import {
  clearCurrentPage,
  setCurrentPage,
  setPageLimit,
} from "../pagination/paginationSlice";
import { BsBookmarkPlusFill } from "react-icons/bs";
import { TbReceiptRupee } from "react-icons/tb";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormFileUpload from "../../components/formFields/FormFileUpload";
import leadSample from "../../assets/Excels/lead_sample.xlsx";
import {
  closeCompleteFollowupDialog,
  openCompleteFollowupDialog,
} from "../inquiry/inquirySlice";
import { setFolloupID } from "../dashboard/dashboardSlice";
import { motion } from "framer-motion";
import { LuHistory } from "react-icons/lu";
import { opened } from "../../components/drawer/drawerSlice";
import { IDrawerState } from "../../components/drawer/drawerModel";
import { saveAs } from "file-saver";

const Lead: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  return (
    <>
      <DeleteLeadDialog />
      <LeadHistoryDialog />
      <LeadFollowUpDialog />
      <BulkUploadLeadDialog />
      <ExcelDownloadDialog />
      <LeadStageDialog />
      <LeadFollowUpListDialog />
      <FollowupCompleteDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconButton
              fillMode="solid"
              title="Back"
              onClick={() => navigate(-1)}
              icon={MdKeyboardBackspace}
              iconClassName="absolute-position"
              style={{ height: 30 }}
              iconStyle={{ fontSize: "20px" }}
            />
            <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
              Lead List
            </Typography.h4>
          </div>

          <div>
            {isAddAccess && (
              <ButtonCreate label="Add New" drawerName="leadForm" />
            )}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <LeadGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const LeadGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const ContactID = location.state?.ContactID;
  const searchParams = parseQueryParams(location.search);

  const isAddAccess = checkAcessRights("/inquiry", INSERT_ACCESS);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS,
  );

  const LeadList = useAppSelector((state) => state.lead.LeadList);
  const activeTabIndex = useAppSelector((state) => state.lead.activeTabIndex);
  const loading = useAppSelector((state) => state.lead.loading);
  const formLoading = useAppSelector((state) => state.lead.formLoading);
  const UserList = useAppSelector((state) => state.user.UserList);
  const LeadFilterDetails = useAppSelector(
    (state) => state.lead.LeadFilterDetails,
  );
  const LeadStageCounts = useAppSelector((state) => state.lead.LeadStageCounts);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const UserTypeIDString = useAppSelector(
    (state) => state.login.loginDetails.UserTypeID,
  );
  const UserTypeID = parseInt(UserTypeIDString);

  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>({});
  const [rowSelectionModel, setRowSelectionModel] = React.useState<number[]>(
    [],
  );

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userRights: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userRights = JSON.parse(userResponseString);
  } catch (error) {
    userRights = [];
  }

  const isQuotationAccess =
    userRights?.some((e: any) => e.MenuKey === "quotation") ?? false;
  const isInquiryAccess =
    userRights?.some((e: any) => e.MenuKey === "inquiry") ?? false;

  useEffect(() => {
    setSelectedState({});
    setRowSelectionModel([]);
  }, [LeadList]);

  useEffect(() => {
    if (searchParams?.LeadID) {
      const drawerOptions: IDrawerState = {
        open: true,
        anchor: "right",
        name: "leadForm",
        drawerWidth: 400,
        data: +searchParams?.LeadID,
        label: "Update Lead",
      };
      dispatch(opened(drawerOptions));
    }
  }, [searchParams?.LeadID]);

  useEffect(() => {
    dispatch(getAllActiveUsers());
    dispatch(getAllAdNames());

    return () => {
      dispatch(closeDialog());
      dispatch(setactiveTabIndex(0));
      dispatch(closeCompleteFollowupDialog());
      dispatch(setCurrentPage(0));
      dispatch(setPageLimit(50));
      dispatch(
        setLeadFilterDetails({
          ...LeadFilterDetails,
          filterContactID: "",
        }),
      );
    };
  }, []);

  useEffect(() => {
    if (
      (!ContactID && !LeadFilterDetails?.filterContactID) ||
      (ContactID && LeadFilterDetails?.filterContactID)
    ) {
      dispatch(
        getAllLeads({
          ...LeadFilterDetails,
          limit: +pageLimit,
          skip: +currentPage * +pageLimit,
        }),
      );
    }
  }, [LeadFilterDetails, pageLimit, currentPage]);

  const dataState = LeadList?.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem),
  );

  const DATA_ITEM_KEY: string = "ID";
  const SELECTED_FIELD: string = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);
      const trueKeys = Object.keys(newSelectedState)
        .filter((key) => newSelectedState[key])
        .map(Number);
      setRowSelectionModel(trueKeys);
    },
    [selectedState],
  );

  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: { [key: string]: boolean } = {};

      event?.dataItems?.forEach((item: any) => {
        newSelectedState[idGetter(item)] = checked;
      });
      setSelectedState(newSelectedState);
      const trueKeys = Object.keys(newSelectedState)
        .filter((key: string) => newSelectedState[key])
        .map(Number);
      setRowSelectionModel(trueKeys);
    },
    [],
  );

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleAddInquiry = (LeadID: number) => {
      navigate("/inquiry/create", {
        state: {
          LeadID: LeadID,
        },
      });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteLead"));
      dispatch(setLeadID(ID));
    };

    const handleShowHistory = async (ID: number) => {
      const res = await dispatch(getLeadAssignUserHistory({ LeadID: `${ID}` }));
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(openDialog("leadHistory"));
      }
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{ ...props.style, right: 0 }}
      >
        {isEditAccess && (
          <ButtonEdit ID={props.dataItem.ID} drawerName="leadForm" />
        )}
        {isAddAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Create Inquiry"
            onClick={() => handleAddInquiry(props.dataItem.ID)}
            icon={LiaInfoSolid}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {UserTypeID < 3 && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="User Assign History"
            themeColor="dark"
            onClick={() => handleShowHistory(props.dataItem.ID)}
            icon={LuHistory}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const CustomLeadStageCell = (props: any) => {
    const handleOpenFollowUpDialog = (ID: number) => {
      dispatch(openDialog("leadFollowUp"));
      dispatch(setLeadID(ID));
    };

    const handleOpenLeadStageDialog = (data: any) => {
      dispatch(openDialog("leadStageChange"));
      dispatch(setLeadID(data?.ID));
      dispatch(setLeadStageID(data?.LeadStageID));
    };

    const handleOpenFollowUpListDialog = (ID: number) => {
      dispatch(
        getFollowupsByInquiryID({
          ID: ID,
          FollowupType: "LEAD",
        }),
      );
      dispatch(openDialog("leadFollowUpList"));
      dispatch(setLeadID(ID));
    };

    return (
      <td
        {...props.tdProps}
        className={`${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <span
          className="mb-2 d-inline-block hoverable-leadstatus"
          style={{ cursor: "pointer" }}
          onClick={() => handleOpenLeadStageDialog(props.dataItem)}
        >
          {props.dataItem?.LeadStage} <IconComponent icon={RiEdit2Fill} />
        </span>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <Button
            themeColor={"primary"}
            type="button"
            fillMode="solid"
            size="small"
            className="d-block"
            onClick={() => handleOpenFollowUpDialog(props.dataItem.ID)}
          >
            Follow Up
          </Button>
          <Button
            themeColor={"primary"}
            type="button"
            fillMode="solid"
            size="small"
            className="d-block"
            onClick={() => handleOpenFollowUpListDialog(props.dataItem.ID)}
          >
            Follow Up List {`(${props.dataItem.TotalNoofFollowup || 0})`}
          </Button>
        </div>
      </td>
    );
  };

  const ListingButtonCell = (props: any) => {
    const handleInquiries = (ID: number) => {
      navigate("/inquiry", { state: { LeadID: ID } });
    };
    const handleQuotations = (ID: number) => {
      navigate("/quotation", { state: { LeadID: ID } });
    };
    const handleBookings = (ID: number) => {
      navigate("/tourbooking", { state: { LeadID: ID } });
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps?.style }}
      >
        {isInquiryAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Inquiries"
            themeColor="info"
            style={{ marginRight: 5 }}
            onClick={() => handleInquiries(props.dataItem.ID)}
            icon={LiaInfoSolid}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {isQuotationAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Quotations"
            themeColor="success"
            style={{ marginRight: 5 }}
            onClick={() => handleQuotations(props.dataItem.ID)}
            icon={TbReceiptRupee}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {false && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Bookings"
            themeColor="tertiary"
            onClick={() => handleBookings(props.dataItem.ID)}
            icon={BsBookmarkPlusFill}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === (UserTypeID < 3 ? 7 : 6) ||
        props.index === (UserTypeID < 3 ? 8 : 7)
          ? "locked-header"
          : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleTabChange = (index: number) => {
    dispatch(clearCurrentPage());
    dispatch(setactiveTabIndex(index));
    dispatch(
      setLeadFilterDetails({
        ...LeadFilterDetails,
        filterLeadStageID: index === 0 ? 1 : index === 1 ? 2 : null,
        filterUnassignedLeads: index === 3 ? true : false,
      }),
    );
  };

  const handleOpenBulkUploadDialog = () => {
    dispatch(openDialog("bulkUploadLead"));
  };

  const handleOpenExcelDownloadDialog = () => {
    dispatch(openDialog("filterforleadexceldownload"));
  };

  const handleSubmit = async (
    values: any,
    formRenderProps: FormRenderProps,
  ) => {
    if (rowSelectionModel?.length < 1) {
      ErrorToast("Please select atleast one!!!");
    } else {
      try {
        const payload = {
          LeadID: rowSelectionModel ? rowSelectionModel?.join(", ") : "",
          UserID: values?.User ? +values?.User : null,
        };
        const response = await dispatch(assignLeadToUser(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          formRenderProps.onChange("User", { value: null });
          dispatch(
            getAllLeads({
              ...LeadFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            }),
          );
          // dispatch(clearLeadDetails());
          // navigate("/lead");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  const gridRef = useRef<any>(null);

  return (
    <>
      {(loading || formLoading) && <LoadingPanel gridRef={gridRef} />}
      <div
        style={{
          position: "relative",
          marginBottom: "10px",
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <LeadFilter />
      </div>
      <Form
        // onSubmit={handleSubmit}
        // initialValues={LeadDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "end",
                justifyContent: "space-between",
                padding: "10px",
                border: "1px solid lightgray",
                borderRadius: "5px",
                boxShadow: "0 0 10px gainsboro",
              }}
            >
              {UserTypeID < 3 && (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "end",
                  }}
                >
                  <Field
                    wrapperClassName="m-0"
                    wrapperStyle={{ minWidth: 300 }}
                    name="User"
                    label="User"
                    placeholder="Select User"
                    component={FormSelectionField}
                    options={UserList?.map((user: IUser) => ({
                      value: user?.ID,
                      label: `${user?.FirstName} ${user?.LastName}`,
                    }))}
                  />
                  <Button
                    themeColor={"primary"}
                    fillMode={"solid"}
                    disabled={
                      !formRenderProps.valueGetter("User") ||
                      rowSelectionModel?.length < 1
                    }
                    onClick={() =>
                      handleSubmit(
                        { User: formRenderProps.valueGetter("User") },
                        formRenderProps,
                      )
                    }
                  >
                    Assign
                  </Button>
                </div>
              )}
              <div className="d-flex gap-2 ">
                {isExcelAccess && (
                  <Button
                    themeColor={"primary"}
                    fillMode={"solid"}
                    onClick={() => handleOpenExcelDownloadDialog()}
                  >
                    Excel Download
                  </Button>
                )}
                {isAddAccess && (
                  <Button
                    themeColor={"primary"}
                    fillMode={"solid"}
                    onClick={() => handleOpenBulkUploadDialog()}
                  >
                    Bulk Upload
                  </Button>
                )}
              </div>
            </div>
          </FormElement>
        )}
      />
      <div
        style={{
          marginTop: 10,
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <div style={{ display: "flex", gap: 10 }} className="mt-1 mb-3">
          <Button
            themeColor={"primary"}
            fillMode={
              LeadFilterDetails?.filterLeadStageID === 1 || activeTabIndex === 0
                ? "solid"
                : "outline"
            }
            onClick={() => handleTabChange(0)}
          >
            Fresh Leads{" "}
            {LeadStageCounts?.TotalNew ? `(${LeadStageCounts?.TotalNew})` : ""}
          </Button>
          <Button
            themeColor={"primary"}
            fillMode={
              LeadFilterDetails?.filterLeadStageID === 2 || activeTabIndex === 1
                ? "solid"
                : "outline"
            }
            onClick={() => handleTabChange(1)}
          >
            Callback Leads{" "}
            {LeadStageCounts?.TotalCallback
              ? `(${LeadStageCounts?.TotalCallback})`
              : ""}
          </Button>
          <Button
            themeColor={"primary"}
            fillMode={activeTabIndex === 2 ? "solid" : "outline"}
            onClick={() => handleTabChange(2)}
          >
            Overall Leads{" "}
            {LeadStageCounts?.OverallLeads
              ? `(${LeadStageCounts?.OverallLeads})`
              : ""}
          </Button>
          {UserTypeID < 3 && (
            <Button
              themeColor={"primary"}
              fillMode={activeTabIndex === 3 ? "solid" : "outline"}
              onClick={() => handleTabChange(3)}
            >
              Un-Assigned{" "}
              {LeadStageCounts?.TotalUnassigned
                ? `(${LeadStageCounts?.TotalUnassigned})`
                : ""}
            </Button>
          )}
        </div>
        {/* {LeadList && LeadList.length ? ( */}
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 370px)" }}
          className="responsive-table"
          filterable={false}
          dataItemKey={DATA_ITEM_KEY}
          data={LeadList?.map((item: any) => ({
            ...item,
            [SELECTED_FIELD]: selectedState[idGetter(item)],
          }))}
          total={LeadList[0]?.ItemCount || LeadList?.length}
          skip={currentPage * pageLimit}
          take={pageLimit}
          selectedField={SELECTED_FIELD}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 50, 100, 500],
            pageSizeValue: pageLimit,
            type: "input",
          }}
          onSelectionChange={onSelectionChange}
          onHeaderSelectionChange={onHeaderSelectionChange}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          {UserTypeID < 3 && (
            <Column
              filterable={false}
              field={SELECTED_FIELD}
              width={50}
              headerSelectionValue={
                dataState?.findIndex(
                  (item: any) => !selectedState[idGetter(item)],
                ) === -1
              }
            />
          )}
          <Column
            field="Name"
            title="Name"
            width={300}
            cell={(props: any) => (
              <td>
                {isEditAccess ? (
                  <>
                    <LinkEdit ID={props.dataItem.ID} drawerName="leadForm">
                      <div className="hoverableName">
                        {props.dataItem?.FirstName} {props.dataItem?.LastName}
                      </div>
                    </LinkEdit>
                    <p className="m-0"> {props.dataItem?.MobileNo}</p>
                    <p className="m-0"> {props.dataItem?.EmailID}</p>
                  </>
                ) : (
                  <div className="normalName">
                    <p className="m-0">
                      {props.dataItem?.FirstName} {props.dataItem?.LastName}
                    </p>
                    <p className="m-0"> {props.dataItem?.MobileNo}</p>
                    <p className="m-0"> {props.dataItem?.EmailID}</p>
                  </div>
                )}
              </td>
            )}
          />
          <Column
            field="LeadDate"
            title="Lead Date"
            width={200}
            cell={(props: any) => {
              const toDay = moment();
              const LeadDate = moment(
                String(props.dataItem?.LeadDate),
                "DD/MM/YYYY",
                true,
              );
              let remainingDuration = "";

              if (toDay.isValid() && LeadDate.isValid()) {
                const duration = moment?.duration(toDay?.diff(LeadDate));
                const durationChunks = {
                  years: duration.years(),
                  months: duration.months(),
                  days: duration.days(),
                };

                remainingDuration = `${
                  durationChunks.years > 0
                    ? `${durationChunks.years} Years and `
                    : ""
                } ${
                  durationChunks.months > 0
                    ? `${durationChunks.months} Months and `
                    : ""
                } ${durationChunks.days} Days`;
              }

              return (
                <td>
                  <p className="m-0">{props.dataItem?.LeadDate}</p>
                  <p className="m-0">{remainingDuration}</p>
                </td>
              );
            }}
          />
          <Column
            field="LeadSource"
            title="Lead Source"
            width={200}
            cells={{
              data: (props: any) => (
                <td>
                  <p className="mb-0">{props.dataItem?.LeadSource}</p>
                  <p className="mb-0 fw-semibold">{props.dataItem?.AdName}</p>
                </td>
              ),
            }}
          />
          <Column
            field="LeadType"
            title="Lead Type"
            width={150}
            cells={{
              data: (props: any) => (
                <td className="text-center fw-bold">
                  {props.dataItem?.LeadType}
                </td>
              ),
            }}
          />
          <Column
            field="LeadStage"
            title="Lead Stage"
            width={270}
            cells={{ data: CustomLeadStageCell }}
          />
          <Column field="LeadOwnerName" title="Owner" width={200} />
          {(isInquiryAccess || isQuotationAccess) && (
            <Column
              field="ID"
              title="Details"
              cells={{ data: ListingButtonCell }}
              width={"150px"}
              filterable={false}
              locked={true}
            />
          )}
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"170px"}
            filterable={false}
            locked={true}
          />
        </KendoGrid>
      </div>
    </>
  );
};

const DeleteLeadDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const LeadID = useAppSelector((state) => state.lead.LeadID);
  const LeadFilterDetails = useAppSelector(
    (state) => state.lead.LeadFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteLead(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(
          getAllLeads({
            ...LeadFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
        dispatch(closeDialog());
        dispatch(clearLeadID());
      } else {
        dispatch(
          getAllLeads({
            ...LeadFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
        dispatch(closeDialog());
        dispatch(clearLeadID());
      }
    }
  };
  return (
    <>
      {dialogName === "deleteLead" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Lead?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Lead?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(LeadID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};
const LeadHistoryDialog: React.FC = () => {
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const LeadAssignUserHistory = useAppSelector(
    (state) => state.lead.LeadAssignUserHistory,
  );

  return (
    <>
      {dialogName === "leadHistory" && (
        <AppDialog>
          <>
            <Typography.h5>{"Lead History"}</Typography.h5>
            <GridLayout style={{ minWidth: 700 }}>
              <GridLayoutItem
                style={{
                  maxHeight: "450px",
                  overflowY: "auto",
                }}
              >
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ background: "black", color: "white" }}>
                        Assigned Time
                      </th>
                      <th style={{ background: "black", color: "white" }}>
                        Assigned To
                      </th>
                      <th style={{ background: "black", color: "white" }}>
                        Assigned By
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {LeadAssignUserHistory.map((record: any) => (
                      <tr>
                        <td>{record?.AssignedTime}</td>
                        <td>{record?.AssignedTo}</td>
                        <td>{record?.AssignedBy}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: 10,
                }}
              >
                <DialogCloseButton themeColor="error" fillMode={"solid"} />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const BulkUploadLeadDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const LeadFilterDetails = useAppSelector(
    (state) => state.lead.LeadFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const loading = useAppSelector((state) => state.lead.bulkUploadLoading);

  const handleSubmit = async (values: any) => {
    const formData = new FormData();
    formData.append("file", values?.LeadsDocument[0]?.getRawFile());

    dispatch(bulkUploadLeads(formData)).then((res: any) => {
      if (res?.payload?.Status === 200) {
        dispatch(closeDialog());
        dispatch(
          getAllLeads({
            ...LeadFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
      }
    });
  };

  return (
    <>
      {dialogName === "bulkUploadLead" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Form
              onSubmit={handleSubmit}
              render={() => (
                <FormElement style={{ minWidth: 500 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Bulk Upload Leads"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="LeadsDocument"
                        type="file"
                        filetype="file"
                        label="Leads File"
                        accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        multiple={false}
                        component={FormFileUpload}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 20,
                      }}
                    >
                      <Button
                        themeColor={"primary"}
                        fillMode={"solid"}
                        style={{ marginRight: 10 }}
                        onClick={() => window.open(leadSample)}
                      >
                        Show Sample
                      </Button>
                      <div>
                        <DialogCloseButton themeColor="primary" />
                        <ButtonWithLoading
                          label={"Upload"}
                          type="submit"
                          // disabled={!formRenderProps.allowSubmit || formLoading}
                          // loading={formLoading}
                        />
                      </div>
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const LeadFollowUpDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const LeadID = useAppSelector((state) => state.lead.LeadID);
  const loading = useAppSelector((state) => state.inquiry.loading);
  const LeadFilterDetails = useAppSelector(
    (state) => state.lead.LeadFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleSubmit = async (values: any) => {
    if (LeadID) {
      const Payload = {
        LeadID: LeadID ? +LeadID : null,
        InquiryID: 0,
        FollowupType: "LEAD",
        FollowupDate: values?.FollowupDate
          ? moment(values?.FollowupDate)?.format("YYYY-MM-DD")
          : "",
        FollowupTime: values?.FollowupTime
          ? moment(values?.FollowupTime)?.format("HH:mm:ss")
          : "",
        Remarks: values?.Remarks ? values?.Remarks : "",
        FollowupStatus: "",
        // IsCompleted: values?.IsCompleted ? values?.IsCompleted : false,
      };
      try {
        const response = await dispatch(insertFollowUp(Payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(
            getAllLeads({
              ...LeadFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            }),
          );
          dispatch(closeDialog());
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {dialogName === "leadFollowUp" && (
        <AppDialog>
          <>
            <Form
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 500 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Add Follow Up"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name={"FollowupDate"}
                        label="Follow up Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        astrike={true}
                        validator={requiredValidator}
                        minDate={moment().toDate()}
                      />
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        wrapperClassName="w-100"
                        id={"FollowupTime"}
                        name={"FollowupTime"}
                        label={"Follow up Time"}
                        component={FormTimePicker}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="mb-2">
                      <Field
                        id={"Remarks"}
                        name={"Remarks"}
                        label={"Remarks"}
                        placeholder={"Remarks"}
                        component={FormTextArea}
                      />
                    </GridLayoutItem>
                    {/* <GridLayoutItem>
                      <Field
                        wrapperClassName="fw-600"
                        name={"IsCompleted"}
                        label={"Is Completed"}
                        Size="medium"
                        component={FormCheckbox}
                      />
                    </GridLayoutItem> */}
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <DialogCloseButton themeColor="primary" />
                      <ButtonForAll
                        style={{ marginLeft: 6 }}
                        label={"Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const LeadStageDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const LeadID = useAppSelector((state) => state.lead.LeadID);
  const LeadStageID = useAppSelector((state) => state.lead.LeadStageID);
  const loading = useAppSelector((state) => state.inquiry.loading);
  const LeadStageList = useAppSelector(
    (state) => state.leadStage.LeadStageList,
  );
  const LeadFilterDetails = useAppSelector(
    (state) => state.lead.LeadFilterDetails,
  );

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    dispatch(getAllActiveLeadStage("LEAD"));
  }, []);

  const handleSubmit = async (values: any) => {
    if (LeadID) {
      const Payload = {
        ID: LeadID ? +LeadID : null,
        LeadStageID: values?.LeadStageID ? +values?.LeadStageID : null,
      };
      try {
        const response = await dispatch(updateLeadStageStatus(Payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(
            getAllLeads({
              ...LeadFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            }),
          );
          dispatch(closeDialog());
          dispatch(clearLeadID());
          dispatch(clearLeadStageID());
        } else {
          dispatch(
            getAllLeads({
              ...LeadFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            }),
          );
          dispatch(closeDialog());
          dispatch(clearLeadID());
          dispatch(clearLeadStageID());
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {dialogName === "leadStageChange" && (
        <AppDialog>
          <>
            <Form
              initialValues={{
                LeadStageID: LeadStageID,
              }}
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 300 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h5 className="typography-head">
                        {"Update Lead Status"}
                      </Typography.h5>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ top: 1 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"LeadStageID"}
                        name={"LeadStageID"}
                        label={"Lead stage"}
                        placeholder="Lead stage"
                        component={FormSelectionField}
                        options={LeadStageList?.map((leadstage: ILeadStage) => {
                          return {
                            value: leadstage?.ID,
                            label: leadstage?.LeadStage,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: 20,
                      }}
                    >
                      <DialogCloseButton themeColor="primary" />
                      <ButtonForAll
                        style={{ marginLeft: 6 }}
                        label={"Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const LeadFollowUpListDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.inquiry.loading);
  const InquiryFollowupList = useAppSelector(
    (state) => state.inquiry.InquiryFollowupList,
  );

  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.1,
        duration: 0.5,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const handleOpenCompleteFollowupDialog = (ID: number) => {
    dispatch(openCompleteFollowupDialog());
    dispatch(setFolloupID(ID));
  };

  return (
    <>
      {dialogName === "leadFollowUpList" && (
        <AppDialog>
          <div style={{ minWidth: 600, maxWidth: 800 }}>
            <GridLayoutItem className="position-relative">
              <Typography.h4 className="typography-head">
                {"Follow Up List"}
              </Typography.h4>
              <IconButton
                className="typography-dialog-close-icon"
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4, top: 7 }}
                onClick={() => dispatch(closeDialog())}
                icon={RxCross1}
              />
            </GridLayoutItem>
            {loading && <LoadingPanel gridRef={gridRef} />}
            {!loading && (
              <motion.ul
                className="followups-list"
                variants={listVariants}
                initial="hidden"
                animate="visible"
                // key={activeTab}
                style={{
                  maxHeight: 300,
                  overflowX: "auto",
                  scrollbarWidth: "thin",
                }}
              >
                {InquiryFollowupList?.length > 0 ? (
                  InquiryFollowupList.map((followUp) => (
                    <motion.li
                      key={followUp.ID}
                      className="followup-item"
                      variants={itemVariants}
                      style={{
                        padding: "4px",
                        background: followUp?.IsCompleted
                          ? "#33ff3340"
                          : "transparent",
                      }}
                      // onClick={() => handleEditLeadOrInquiry(followUp)}
                    >
                      <div className="text-end">
                        Added by: {followUp.FollowUpAddedbyName}
                      </div>
                      <div className="followup-header">
                        <span className="lead-name">{followUp.Name}</span>
                        <span className="followup-date-time">
                          {followUp.FollowupDate} | {followUp.FollowupTime}
                        </span>
                      </div>
                      <div className="followup-header gap-2 mt-1">
                        <p className="followup-description">
                          {followUp.Remarks}
                        </p>
                        {
                          !followUp.IsCompleted && (
                            <span className="followup-date-time">
                              <motion.button
                                className={`tab-btn active`}
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  handleOpenCompleteFollowupDialog(
                                    followUp?.ID || 0,
                                  );
                                }}
                                whileHover={{
                                  scale: 1.05,
                                  transition: { duration: 0.2 },
                                }}
                                whileTap={{ scale: 0.95 }}
                                style={{ padding: "5px 10px" }}
                              >
                                Complete
                              </motion.button>
                            </span>
                          )
                          //  : (
                          //   <span
                          //     style={{
                          //       padding: "5px 10px",
                          //       borderRadius: "5px",
                          //       background: "#109510",
                          //       fontWeight: "bold",
                          //       color: "white",
                          //     }}
                          //   >
                          //     Completed
                          //   </span>
                          // )
                        }
                      </div>
                      {followUp?.IsCompleted && (
                        <div
                          className="followup-header gap-3 mt-1"
                          style={{ background: "palegreen" }}
                        >
                          <p className="followup-description">
                            <b>Completion Remarks :</b>{" "}
                            {followUp?.CompletedRemarks}
                          </p>
                          <span className="" style={{ whiteSpace: "nowrap" }}>
                            {followUp.CompletedDate}{" "}
                            {followUp.CompletedDate &&
                              followUp.CompletedTime &&
                              "|"}{" "}
                            {followUp.CompletedTime}
                          </span>
                        </div>
                      )}
                    </motion.li>
                  ))
                ) : (
                  <motion.p key="no-followups" className="no-followups">
                    No follow-ups found for this Inquiry.
                  </motion.p>
                )}
              </motion.ul>
            )}
            <GridLayoutItem
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: 20,
              }}
            >
              <DialogCloseButton themeColor="primary" />
            </GridLayoutItem>
          </div>
        </AppDialog>
      )}
    </>
  );
};

const FollowupCompleteDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const completeFollowupOpen = useAppSelector(
    (state) => state.inquiry.completeFollowupOpen,
  );
  const followUpLoading = useAppSelector(
    (state) => state.dashboard.followUpLoading,
  );
  const followupId = useAppSelector((state) => state.dashboard.followupId);
  const LeadID = useAppSelector((state) => state.lead.LeadID);

  const handleSubmit = async (values: any) => {
    const payload = {
      ID: followupId ? +followupId : null,
      CompletedRemarks: values?.CompletedRemarks
        ? values?.CompletedRemarks
        : "",

      IsCompleted: true,
    };
    if (followupId) {
      const res = await dispatch(updateFollowUpStatus(payload));
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          getFollowupsByInquiryID({
            ID: LeadID,
            FollowupType: "LEAD",
          }),
        );
        dispatch(closeCompleteFollowupDialog());
      }
    }
  };

  return (
    <>
      <CustomAppDialog open={completeFollowupOpen}>
        <>
          {followUpLoading && <LoadingPanel gridRef={gridRef} />}
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ minWidth: 500 }}>
                <GridLayout>
                  <GridLayoutItem className="position-relative">
                    <Typography.h4 className="typography-head">
                      {"Complete Followup"}
                    </Typography.h4>
                    <IconButton
                      className="typography-dialog-close-icon"
                      type="button"
                      fillMode={"flat"}
                      themeColor={"dark"}
                      style={{ marginRight: 4, top: 7 }}
                      onClick={() => dispatch(closeCompleteFollowupDialog())}
                      icon={RxCross1}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"CompletedRemarks"}
                      name={"CompletedRemarks"}
                      label={"Completed Remarks"}
                      placeholder={"Completed Remarks"}
                      component={FormTextArea}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginTop: 20,
                    }}
                  >
                    <CustomDialogCloseButton
                      themeColor="primary"
                      closeDialogFunction={closeCompleteFollowupDialog}
                    />
                    <ButtonWithLoading
                      label={"Complete"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || followUpLoading}
                      loading={followUpLoading}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </>
      </CustomAppDialog>
    </>
  );
};

const ExcelDownloadDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.lead.excelDownloadLoading);
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS,
  );
  const LeadStageList = useAppSelector(
    (state) => state.leadStage.LeadStageList,
  );
  const UserList = useAppSelector((state) => state.user.UserList);
  const AdNamesList = useAppSelector((state) => state.lead.AdNamesList);

  const handleSubmit = async (values: any) => {
    const payload = {
      filterLeadStageID: values?.filterLeadStageID
        ? +values?.filterLeadStageID
        : 0,
      filterLeadType: values?.filterLeadType ? values?.filterLeadType : "",
      filterLeadSourceID: values?.filterLeadSourceID
        ? +values?.filterLeadSourceID
        : 0,
      filterAssignedTo: values?.filterAssignedTo
        ? +values?.filterAssignedTo
        : 0,
      filterFromDate: values?.filterFromDate
        ? moment(values?.filterFromDate).format("YYYY-MM-DD")
        : "",
      filterToDate: values?.filterToDate
        ? moment(values?.filterToDate).format("YYYY-MM-DD")
        : "",
      AdName: values?.AdName ? values?.AdName : "",
    };
    const response = await dispatch(downloadLeadExcel(payload));

    if (response.meta.requestStatus === "fulfilled" && response?.payload) {
      const byteArray = response.payload;

      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "leadlist.xlsx");
      SuccessToast("Excel download succeessfully!");
      dispatch(closeDialog());
    }
  };

  return (
    <>
      {dialogName === "filterforleadexceldownload" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Form
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 600 }}>
                  <GridLayout
                    cols={[{ width: "49.5%" }, { width: "49.5%" }]}
                    gap={{ rows: 10, cols: 10 }}
                  >
                    <GridLayoutItem colSpan={2} className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Filter criteria for excel download"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"filterFromDate"}
                        label="From Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"filterToDate"}
                        label="To Date"
                        format="dd/MM/yyyy"
                        validator={requiredValidator}
                        astrike={true}
                        disabled={
                          !formRenderProps.valueGetter("filterFromDate")
                        }
                        component={FormDatePicker}
                        minDate={moment(
                          formRenderProps.valueGetter("filterFromDate"),
                        ).toDate()}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"filterLeadStageID"}
                        label={"Lead stage"}
                        placeholder="Lead stage"
                        component={FormSelectionField}
                        options={LeadStageList?.map((leadstage: ILeadStage) => {
                          return {
                            value: leadstage?.ID,
                            label: leadstage?.LeadStage,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"filterLeadType"}
                        label={"Lead Type"}
                        placeholder="i.e. B2B"
                        component={FormSelectionField}
                        options={LEADTYPE?.map((initial: any) => {
                          return {
                            value: initial?.value,
                            label: initial?.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"filterAssignedTo"}
                        label="Assigned To"
                        placeholder="Select User"
                        component={FormSelectionField}
                        options={UserList?.map((user: IUser) => ({
                          value: user?.ID,
                          label: `${user?.FirstName} ${user?.LastName}`,
                        }))}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="AdName"
                        label="Ad Name"
                        placeholder="Select Ad Name"
                        component={FormSelectionField}
                        options={AdNamesList?.map((initial: any) => {
                          return {
                            value: initial?.AdName,
                            label: initial?.AdName,
                          };
                        })}
                      />
                    </GridLayoutItem>

                    <GridLayoutItem
                      colSpan={2}
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: 10,
                        marginTop: 20,
                      }}
                    >
                      <Button
                        themeColor={"primary"}
                        fillMode={"outline"}
                        type="button"
                        disabled={loading}
                        onClick={() => dispatch(closeDialog())}
                      >
                        Cancel
                      </Button>
                      {isExcelAccess && (
                        <Button
                          themeColor={"primary"}
                          fillMode={"solid"}
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Downloading..." : "Download"}
                        </Button>
                      )}
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Lead;
